import React from 'react';
import { EditableComponent } from '@adobe/aem-react-editable-components';

import { OTextBlockEditorial as OTextBlockEditorialComp } from '@marriott/mi-web-ui-kit';
import clsx from 'clsx';

export const OTextBlockEditorialConfig = {
  emptyLabel: 'OTextBlockEditorial',
  isEmpty: () => true,
  resourceType: `${process.env['NEXT_PUBLIC_AEM_SITE']}/components/content/o-text-block-editorial`,
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const OTextBlockEditorial = (props: any) => {
  const model = props.model || {};
  const { styleclass, componentId } = model;

  return (
    <div
      data-testid="o-text-block-editorial-comp"
      data-component-name="o-text-block-editorial"
      id={componentId}
      className={clsx(styleclass)}
    >
      <EditableComponent config={OTextBlockEditorialConfig} {...props}>
        <OTextBlockEditorialComp {...props} />
      </EditableComponent>
    </div>
  );
};
